import React, { FC, useRef } from 'react';
import { IonContent, IonModal } from '@ionic/react';
import { Container, CustomButton } from '@mindly/ui-components';
import { ErrorPaymentModalWrapper } from './ErrorPaymentModal.style';
import PaymentErrorIcon from './error-payment-icon.svg?react';
import { FormattedMessage } from 'react-intl';

type ErrorPaymentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
};

const ErrorPaymentModal: FC<ErrorPaymentModalProps> = ({ isOpen, message, onClose }) => {
  const modalRef = useRef<HTMLIonModalElement>(null);

  return (
    <IonModal
      ref={modalRef}
      mode={'ios'}
      isOpen={isOpen}
      onDidDismiss={onClose}
      animated={false}
      backdropDismiss={false}
    >
      <IonContent>
        <Container>
          <ErrorPaymentModalWrapper>
            <PaymentErrorIcon className={'error-icon'} />
            <div className={'error-title'}>
              <FormattedMessage id={'subscription.payment.error.title'} defaultMessage={'Сталася помилка з оплатою'} />
            </div>
            <div className={'error-message'}>{message}</div>
            <div className={'error-repeat'}>
              <FormattedMessage
                id={'subscription.payment.error.repeat'}
                defaultMessage={'Будь ласка, спробуйте ще раз.'}
              />
            </div>
            <CustomButton buttonType={'primary'} onClick={() => modalRef.current?.dismiss()}>
              <FormattedMessage id={'understand.btn'} defaultMessage={'Зрозуміло'} />
            </CustomButton>
          </ErrorPaymentModalWrapper>
        </Container>
      </IonContent>
    </IonModal>
  );
};

export default ErrorPaymentModal;
